<div class="fwd-roll-pricing__container" fxLayout="column">
  <div #blottersContainer class="fwd-roll-pricing__blotters__container" fxFlex="1 1">
    <p-tabView
      [activeIndex]="selectedTab"
      #tabview
      (onChange)="onTabSelected($event)"
      styleClass="bfx-tabview"
    >
      <p-tabPanel header="{{labels.tabs.summary}}" #tabSummary>
        <div fxLayout="column">
          <bfx-fwd-roll-currencies-grid
            [style.height.px]="height"
            class="fwd_roll_splitter_top"
            #currenciesGrid
            [portfolioModel]="portfolioModel"
          >
          </bfx-fwd-roll-currencies-grid>

          <div [ngClass]="{ }" class="splitter-gutter" fxFlex="0 0 auto">
            <div class="handle-container" (mousedown)="onResizeClick($event)">
              <div class="indicator"></div>
              <div class="indicator"></div>
            </div>
          </div>
          <div class="pairs-divider"></div>

          <bfx-fwd-roll-dealt-pairs-grid
            class="fwd_roll_splitter_bottom"
            #pairsGrid
            [portfolioModel]="portfolioModel"
          >
          </bfx-fwd-roll-dealt-pairs-grid>
        </div>
      </p-tabPanel>
      <p-tabPanel header="{{labels.tabs.orders}}" #tabOrders>
        <bfx-fwd-roll-orders-grid #ordersGrid [portfolioModel]="portfolioModel">
        </bfx-fwd-roll-orders-grid>
      </p-tabPanel>
    </p-tabView>
  </div>
  <!-- FOOTER -->
  <bfx-callout
    *ngIf="data.callout.visible"
    [calloutType]="data.callout.type"
    [message]="data.callout.message"
  ></bfx-callout>
  <div class="fwd-roll-pricing__footer">
    <button
      pButton
      class="bfx-button-secondary-moderate"
      [disabled]="!data.buttons.close.enabled"
      [ngClass]="{'fwd-roll-button-hidden':data.buttons.close.hidden}"
      [label]="labels.buttons.close"
      (click)="closeWindow()"
    ></button>
    <button
      pButton
      class="bfx-button-secondary-moderate"
      [disabled]="!data.buttons.refresh.enabled || portfolioModel.isLockActive"
      [ngClass]="{'fwd-roll-button-hidden':data.buttons.refresh.hidden}"
      [label]="labels.buttons.refresh"
      (click)="refresh()"
    ></button>

    <!-- <div fxFlex="1 1"></div> -->
    <div fxLayout="row" fxFlex="0 1 auto" *ngIf="portfolioModel.isLockActive">
      <span fxFlex="20px">
        <i class="fa icon_ion_loading fa-spin a-fw"></i>
      </span>
      <span class="loading-label"> {{labels.fetching_data}} </span>
    </div>
    <span fxFlex="1 1 auto" class="fwd-roll-footer-label">{{labels.footer_label}}</span>
    <button
      pButton
      class="bfx-button-secondary-bold"
      [disabled]="!data.buttons.save.enabled || portfolioModel.isLockActive"
      [ngClass]="{'fwd-roll-button-hidden':data.buttons.save.hidden}"
      [label]="labels.buttons.save"
      (click)="save()"
    ></button>
    <button
      pButton
      class="bfx-button-primary-bold"
      [disabled]="!data.buttons.price.enabled || portfolioModel.isLockActive"
      [ngClass]="{'fwd-roll-button-hidden':data.buttons.price.hidden}"
      [label]="labels.buttons.price"
      (click)="price()"
    ></button>
  </div>
</div>
